import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import classnames from 'classnames';
import { trackHomepageAppDownloadClick } from 'lib/Tracking';
import styles from './styles';

const MobileAppDownload = (): JSX.Element => {
  const { t } = useTranslation();
  const [phoneViewRef, phoneInView] = useInView({ triggerOnce: true });
  const [wreathViewRef, wreathInView] = useInView({ triggerOnce: true });
  const [buttonsViewRef, buttonsInView] = useInView({ triggerOnce: true });
  return (
    <div className="mobile-app-download" ref={phoneViewRef}>
      <div className="outer-flex-container">
        <h3 className="header">{t('home.mobileAppDownload.getTopRatedApp')}</h3>
        <h4 className="sub-header">
          {t('home.mobileAppDownload.over')} <span>{t('home.mobileAppDownload.million')}</span>{' '}
          {t('home.mobileAppDownload.downloads')}
        </h4>
        <div
          className={classnames('phone-image-mobile', {
            'phone-image-mobile-in-view': phoneInView,
          })}
        />
        <div className="flex-container wreath-container" ref={wreathViewRef}>
          <div
            role="img"
            aria-label="The Street"
            className={classnames('street-wreath', { 'street-wreath-in-view': wreathInView })}
          />
          <div
            role="img"
            aria-label="CNET"
            className={classnames('cnet-wreath', { 'cnet-wreath-in-view': wreathInView })}
          />
        </div>
        <div className="flex-container app-store-container" ref={buttonsViewRef}>
          <a
            target="_blank"
            aria-label={t('accessibility.newWindow')}
            rel="nofollow"
            href="https://itunes.apple.com/us/app/id1058636900?utm_source=homepage&amp;utm_medium=footer-link&amp;utm_campaign=app%20install%20footer%20link"
            className={classnames('app-store-promo', { 'app-store-promo-in-view': buttonsInView })}
            onClick={(): void => trackHomepageAppDownloadClick('download_ios_click', 'iOS')}
          />
          <a
            target="_blank"
            aria-label={t('accessibility.newWindow')}
            rel="nofollow"
            href="https://play.google.com/store/apps/details?id=com.autolist.autolist&referrer=utm_source%3Dhomepage%26utm_medium%3Dfooter-link%26utm_campaign%3Dapp%20install%20footer%20link"
            className={classnames('google-play', { 'google-play-in-view': buttonsInView })}
            onClick={(): void => trackHomepageAppDownloadClick('download_android_click', 'Android')}
          />
        </div>
      </div>
      <div
        role="img"
        aria-label="Phone image"
        ref={phoneViewRef}
        className={classnames('phone-image-desktop', {
          'phone-image-desktop-in-view': phoneInView,
        })}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default MobileAppDownload;
